const FlagBolivia = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="mask0_695_501"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <path
                    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                    fill="#C4C4C4"
                />
            </mask>
            <g mask="url(#mask0_695_501)">
                <path
                    d="M28.7111 -2.48889H0V4.48H28.7111V-2.48889Z"
                    fill="#BC2433"
                />
                <path
                    d="M28.7111 4.47998H0V11.4489H28.7111V4.47998Z"
                    fill="#F0D633"
                />
                <path
                    d="M28.7111 11.449H0V18.4179H28.7111V11.449Z"
                    fill="#347B47"
                />
            </g>
        </svg>
    )
}

export default FlagBolivia
